"use client";
import { sendGTMEvent } from "@next/third-parties/google";
import Link, { LinkProps } from "next/link";
import React from "react";

interface LinkButtonProps extends Omit<
	React.AnchorHTMLAttributes<HTMLAnchorElement>,
	"href"
> {
	text: string;
	href?: string;
	disabled?: boolean;
	icon?: string;
	primary?: boolean;
	target?: string;
	id?: string;
}

export default function LinkButton({
	text,
	href,
	primary = true,
	...props
}: LinkButtonProps) {
	const className = `btn ${primary ? "btn-neutral" : "btn-link"}`;

	if (!href) {
		// Si pas de lien : bouton simple
		return (
			<button
				className={className}
				onClick={() =>
					sendGTMEvent({
						event: "cta_click",
						cta_label: text,
						cta_location: "button_no_cta",
						page_path: window.location.pathname,
					})
				}
			>
				{text}
			</button>
		);
	}

	return (
		<Link
			href={href as string}
			className={className}
			{...props}
			onClick={() =>
				sendGTMEvent({
					event: "cta_click",
					cta_label: text,
					cta_location: location,
					page_path: window.location.pathname,
				})
			}
		>
			{text}
		</Link>
	);
}
